import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

//region [[ Styles ]]
const ContentText = styled("div")(() => ({
  fontSize: "16px",
  marginBottom: "20px",
}));

const ActionsStyled = styled(DialogActions)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "10px",
}));

const ActionButton = styled(Button)(() => ({
  textTransform: "capitalize",
  boxShadow: "none",
  fontSize: "16px",
  marginRight: "5px",
}));
//endregion [[ Styles ]]

//region [[ Props ]]
interface LimitAgeDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
const NEWSLETTER_LINK = "https://kahun.com/contact-us/";
//endregion [[ Functions ]]

export const LimitAgeDialog = ({ isOpen, onClose }: LimitAgeDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Pediatric knowledge graph is under construction</DialogTitle>
      <DialogContent>
        <ContentText>
          Sign up to our{" "}
          <a href={NEWSLETTER_LINK} target="_blank" rel="noopener noreferrer">
            newsletter
          </a>{" "}
          for updates when this section is ready
        </ContentText>
      </DialogContent>
      <ActionsStyled>
        <ActionButton onClick={onClose} color="primary" variant="contained">
          Got it
        </ActionButton>
      </ActionsStyled>
    </Dialog>
  );
};
